import { Injectable } from "@angular/core";
import {UrlBuilderService} from "@feature/common";
import {HttpClient} from "@angular/common/http";
import {MftAllowLists} from "@mft/default-dashboard/models/mft-allow-lists.model";
import {Observable} from "rxjs";

@Injectable({ providedIn: 'root' })
export class MftAllowListHttpDataService {

  constructor(private urlBuilder: UrlBuilderService,
              private http: HttpClient) { }

  public getForCurrentUser(): Observable<MftAllowLists> {
    const url = this.urlBuilder.getUrl('mft-allow-lists');
    return this.http.get<MftAllowLists>(url);
  }
}
